import { gql } from '__generated__';

export default gql(`
  mutation EditInvitation($input: EditInvitationInput!) {
    editInvitation(input: $input) {
      ...InvitationFields
    }
  }
`);
